"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoomPlayerState = void 0;
var RoomPlayerState;
(function (RoomPlayerState) {
    RoomPlayerState["Ready"] = "ready";
    RoomPlayerState["Active"] = "active";
    RoomPlayerState["Pending"] = "pending";
    RoomPlayerState["Returning"] = "returning";
    RoomPlayerState["Inactive"] = "inactive";
    RoomPlayerState["Abandoned"] = "abandoned";
    RoomPlayerState["AwaitingAction"] = "awaiting_action";
})(RoomPlayerState || (exports.RoomPlayerState = RoomPlayerState = {}));
